import React from "react"
import cn from "classnames"
import "./ErrorTitleText.scss"

interface IErrorTitleTextProps {
    title: string
    text: string
    text2?: string
}

const ErrorTitleText = ({ text, title, text2 }: IErrorTitleTextProps) => {
    return (
        <div className="error-title-text-container">
            <div className={cn("title")}>{title}</div>
            <div className={cn("text")}>{text}</div>
            {text2 && <div className={cn("text2")}>{text2}</div>}
        </div>
    )
}

export default ErrorTitleText
